import React, { useState } from "react";
import axios from "axios";
import Header from "./Header.js";
import Footer from "./Footer.js";
import {ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    org_name: "",
    email: "",
    location: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await axios.post("https://restapi.hhcustomtailor.com/api/v1/save-contact/", formData, {
            headers: { "Content-Type": "application/json" }
        });

        // Success Message
        toast.success(
            <>
                Thank You! <br /><br /> Your form was submitted successfully.
            </>,
            {
                position: "top-center",
                theme: "dark",
                autoClose: 3000
            }
        );
      } catch (error) {
        console.error("Error:", error);

        // Error Handling
        toast.error("Submission failed! Please try again.", {
            position: "top-center",
            theme: "dark",
            autoClose: 3000
        });
    }
};

  return (
    <div className="contactus-page">
      <div className="position-relative theme-bg">
        <Header />
        <div className="theme-color d-flex justify-content-center align-items-center padding-top-xxl padding-bottom-xxl">
          <div className="container">
            <h1 className="text-center font-xl mb-4">Let’s Get in Touch</h1>
            <div className="row justify-content-center">
              <div className="col-md-6 col-sm-8 col-10 padding-bottom-xl">
                <div className="p-5 form-bg shadow">
                    <div className="blur-background"></div>
                  <form onSubmit={handleSubmit} className="form-content">
                    <div className="mb-3">
                      <label className="form-label">Your Name:</label>
                      <input
                        type="text"
                        className="form-control theme-color"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Your Organization Name:</label>
                      <input
                        type="text"
                        className="form-control theme-color"
                        name="org_name"
                        value={formData.org_name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Email:</label>
                      <input
                        type="email"
                        className="form-control theme-color"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Location:</label>
                      <input
                        type="text"
                        className="form-control theme-color"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        style = {{width:'300px'}}
                       />
                    </div>
                    <button type="submit" className="btn btn-primary btn-no-bg d-block mx-auto theme-color fw-semibold font-md pt-5">
                        Submit
                    </button>
                    <span><ToastContainer /></span>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Contact;
